import { useQuery } from "@tanstack/react-query";
import { api } from "@/api/client";
import { useSession } from "@/app/session";

/** Whether the signed-in account may open the admin page (the server's HUB_ADMIN_EMAILS). False offline. */
export function useIsAdmin(): boolean {
  const signedIn = useSession((s) => s.isSignedIn && !s.offline);
  const userId = useSession((s) => s.user?.id ?? null);
  const me = useQuery({ queryKey: ["me", "admin", userId], queryFn: () => api.me(), enabled: signedIn, staleTime: 10 * 60_000, retry: false });
  return signedIn && me.data?.admin === true;
}
